import { GETHISTORY_SUCCESS, GETHISTORY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETHISTORY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETHISTORY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getHistoryReducer;
